import { reactive } from 'vue';
import { useQuery } from 'vue-query';
import QUERY_KEYS from '@/constants/queryKeys';
import { FETCH_ONCE_OPTIONS } from '@/constants/vue-query';
import useNetwork from '../useNetwork';
import { balancerFarmSubgraphService } from '@/services/balancer/subgraph/balancer-farm-subgraph.service';

/**
 * Fetch all token lists, should only happen once.
 */
export default function useLpTokenListsQuery() {
  const { networkId } = useNetwork();

  const queryKey = reactive(QUERY_KEYS.LpTokenLists.All(networkId));

  const queryFn = async () => {
    console.log('Fetching LP tokenLists');
    const pools = await balancerFarmSubgraphService.farmPools.get({});
    return pools.map(i => i.lpToken);
  };

  const queryOptions = reactive({
    enabled: true,
    ...FETCH_ONCE_OPTIONS
  });

  return useQuery(queryKey, queryFn, queryOptions);
}
